const { GoogleSpreadsheet } = require('google-spreadsheet');
import credentialsPath from './credentials.json';

export async function getData(docID, sheetID) {
  const result = [];
  const doc = new GoogleSpreadsheet(docID);
  const creds = credentialsPath;
  await doc.useServiceAccountAuth(creds);
  await doc.loadInfo();
  const sheet = doc.sheetsById[sheetID];
  const rows = await sheet.getRows();
  const columns = rows[0]._sheet.headerValues
  console.log(rows)
  console.log(columns)
  rows.forEach(row => {
    result.push(row._rawData)
  });
  return { columns, rows: result };
};
